
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { DollarSign, Users, TrendingUp } from "lucide-react";

const FinanceCenter = () => {
  return (
    <div>
        <h2 className="text-2xl font-semibold mb-4 text-white">💸 Finance & Revenue Center</h2>
        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
            <Card className="bg-white/10 border-white/20 text-white">
                <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
                    <CardTitle className="text-sm font-medium">Total Revenue</CardTitle>
                    <DollarSign className="h-4 w-4 text-gray-400" />
                </CardHeader>
                <CardContent>
                    <div className="text-2xl font-bold">$331,500</div>
                    <p className="text-xs text-gray-400">+20.1% from last month</p>
                </CardContent>
            </Card>
            <Card className="bg-white/10 border-white/20 text-white">
                <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
                    <CardTitle className="text-sm font-medium">Creator Payouts</CardTitle>
                    <Users className="h-4 w-4 text-gray-400" />
                </CardHeader>
                <CardContent>
                    <div className="text-2xl font-bold">$82,875</div>
                    <p className="text-xs text-gray-400">Pending: $12,300</p>
                </CardContent>
            </Card>
            <Card className="bg-white/10 border-white/20 text-white">
                <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
                    <CardTitle className="text-sm font-medium">POS Sales (Bar/Merch)</CardTitle>
                    <TrendingUp className="h-4 w-4 text-gray-400" />
                </CardHeader>
                <CardContent>
                    <div className="text-2xl font-bold">$55,250</div>
                    <p className="text-xs text-gray-400">+12% from last month</p>
                </CardContent>
            </Card>
        </div>
        <div className="mt-6">
            <Card className="bg-white/5 border-white/20 text-white">
                <CardHeader>
                    <CardTitle>Recent Transactions</CardTitle>
                </CardHeader>
                <CardContent>
                    <p className="text-gray-400">A table or list of recent transactions will be here.</p>
                </CardContent>
            </Card>
        </div>
    </div>
  );
};

export default FinanceCenter;
